/**
 * Eligibility rules for the credit calculator: whether a card's model key and model year let
 * the calculator run, plus the age check behind the "model too old" gate.
 */
import { differenceInMonths } from 'date-fns';
import { CardContext } from './calculation/interfaces';

export const MAX_COMPUTABLE_CREDIT_PERIOD_MONTHS = 60;

/**
 * Difference in months between now and the card's model year, anchored to the first of the
 * current month in that year. Used to gate the calculator for models that are too old to price.
 */
export function getModelMonthDifference(modelYear: number): number {
  const currentDate = new Date();
  const modelDate = new Date(modelYear, currentDate.getMonth(), 1);
  return differenceInMonths(currentDate, modelDate);
}

/**
 * The calculator can run only when the card has a model key and a model year within the
 * computable window. A missing key or a missing model year gates the calculator (rather than
 * defaulting the year); the credit dialog and manual entry stay available either way.
 */
export function canUseCalculator(cardContext: CardContext): boolean {
  return (
    Boolean(cardContext.modelKey) &&
    cardContext.modelYear != null &&
    getModelMonthDifference(cardContext.modelYear) <= MAX_COMPUTABLE_CREDIT_PERIOD_MONTHS
  );
}
